<section class="content">
  <div class="card" style="padding:25px">

  <div class="container-fluid">
    <div class="row">
      <div class="col" style="font-size: 23px;font-weight: 500; color: #278ecd; margin-bottom: 25px;">
        {{title}}
      </div>
    </div>


    <div class="row">

      <div class="col-2">
        <mat-label>From Date</mat-label>
        <input type="date" [(ngModel)]="from_date" class="main-border-class" />
      </div>

      <div class="col-2">
        <mat-label>To Date</mat-label>
        <input type="date" [(ngModel)]="to_date" class="main-border-class" [min]="from_date" />
      </div>

      <div class="col-2">
        <mat-label>Customer Type </mat-label>
        <mat-select [(ngModel)]="selected_customer_type" class="main-border-class" (ngModelChange)="changeEvent()">
          <mat-option [value]="customer_type.id" *ngFor="let customer_type of customer_type_list">{{customer_type.name}}</mat-option>
        </mat-select>
      </div>

      <div class="col-2">
        <mat-label>Input </mat-label>
        <mat-select [(ngModel)]="selected_input" class="main-border-class" (ngModelChange)="changeEvent()">
          <mat-option [value]="input" *ngFor="let input of input_list">{{input}}</mat-option>
        </mat-select>
      </div>

      <div class="col-2" *ngIf="selected_input == 'Rid'">
        <mat-label>Type Rid</mat-label>
        <input type="text" [(ngModel)]="selected_rid" class="main-border-class"/>
      </div>

      <div class="col-2" *ngIf="selected_input == 'Status'">
        <mat-label>Stauts </mat-label>
        <mat-select [(ngModel)]="selected_status" class="main-border-class">
          <mat-option [value]="status" *ngFor="let status of status_list">{{status}}</mat-option>
        </mat-select>
      </div>

      <div class="col">
        <button (click)="getClicked()"
          style="font-size: 27px;margin-top: 4%;border-radius: 5px;background: blanchedalmond;"
          [disabled]="to_date == null || from_date == null">Get</button>
      </div>

      <div class="col-2" *ngIf="document_file!== null">
        <button mat-button class="button-class" (click)="downloadClicked()" style="margin-top:25px"><i class="material-icons">
          get_app
          </i> Download Excel</button>
      </div>

    </div>

    <div *ngIf="!is_document_file_avaliable">
      <mat-progress-spinner class="example-margin" [color]="color" [mode]="mode" [diameter]="100">
      </mat-progress-spinner>
    </div>


  </div>
  </div>
</section>
